export default {
  session: {
    user: {},
    authenticated: false,
    checked: true,
  },
  global: {
    loading: 0,
    lastLoading: null,
    stepsWatched: [],
    selected: null,
  },
  login: {
    error: '',
  },
  signup: {
    error: '',
    success: '',
  },
  modalInformation: {
    open: false,
    text: '',
    singlePressPosition: false,
    longPressPosition: false,
    pressAndDragPosition: false,
    swipeUp: false,
    swipeDown: false,
    swipeLeft: false,
    swipeRight: false,
    singlePress: false,
    longPress: false,
    pressAndDrag: false,
    onOpen: false,
    onClose: false,
  },
  socket: {
    rooms: {},
    rooms_back: {},
    rooms_request: {},
    is_connected_to_node: false,
    interval_reconnect_node: null,
  },
  chats: {
    chats: null,
    newMessage: null,
    isLoadingOlder: false,
    mustReloadChats: true,
    mustReloadInvitations: true,
    selectLeaderStatus: null,
  },
};



// WEBPACK FOOTER //
// ./src/store/globalState/initialState.js